import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { isDirect } from "@/lib/mobile";

export function DirectGuard({ children }) {
  const { session } = useAuth();
  return isDirect(session.user, session.tenant) ? <Navigate to="/m/pdv" replace /> : children;
}
